<template>
  <div >
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <div slot="header" class="clearfix dettit">
          <span>权限管理&nbsp;/&nbsp;报备字段可配置</span>
        </div>
      </div>
      <el-row justify="start" type="flex">
        <el-col :span="4" class="col-box">
          <ul class="left-box">
            <li class="title">类别</li>
            <li v-for="(item,index) in categoryList" :key="index" @click="handleSelectCategory(item)" :class="`${item === form.category ? 'current-li':''}`">{{ item }}</li>
          </ul>
        </el-col>
        <el-col :span="20" ><div class="right-box">
          <el-form :inline="true" ref="form" :model="form" >
            <el-form-item label="字段">
              <el-input
                v-model="form.label"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="form.showAble" clearable placeholder="请选择" >
                <el-option label="展示" :value="true" />
                <el-option label="关闭" :value="false" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch"
                         element-loading-text="加载中..."
                         element-loading-background="rgba(0, 0, 0, 0.4)"
                         v-loading.fullscreen.lock="fullscreenLoading">查询</el-button>
              <el-button type="info" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>

          <el-table
            :data="list"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" label="序号" align="center" width="80" :index="1" >
            </el-table-column>
            <el-table-column prop="label" label="字段">
            </el-table-column>
            <el-table-column prop="sort" align="center" label="排序">
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.showAble"
                  active-color="#13ce66" @change="handleSwitch(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <span>共 <i class="pagingNum">{{ page.total }}</i> 条</span>
            <Paging :gopage="page.total" @pag="handlePage"></Paging>
          </div>
        </div>
        </el-col>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import Paging from "@/components/Paging";
export default {
  name: "ReportPropertyConfig",
  components:{
    Paging
  },
  data(){
    return {
      form:{
        label: undefined,
        showAble: undefined,
        category:undefined
      },
      fullscreenLoading: true,
      userdata: {},
      page:{
        total:0,
        pageNumber: 1,
        pageSize: 10,
      },
      categoryList:[],
      list:[]
    }
  },
  computed:{
  },
 created() {
    this.loadCategory().then(()=>{
      this.loadTable();
    })
  },
  methods:{
    handleSelectCategory(categoryName){
      this.form.category = categoryName || undefined
      this.loadTable()
    },
    loadCategory(){
      return new Promise((resolve, reject)=>{
        this.userdata = JSON.parse(sessionStorage.getItem("userdata")) || {}
        this.$axios
          .get(`/api-r/report_property/config/list/category`, {
            headers: {accessToken: this.userdata.token},
          })
          .then((res) => {
            const { data } = res || {}
            if (data.success) {
              this.categoryList = data.data || []
              this.form.category = this.categoryList.length ? this.categoryList[0] : undefined
              resolve()
            }else {
              reject()
            }
          });
      })
    },
    loadTable(){
      let queryParams = {
        category: this.form.category,
        pageNumber: this.page.pageNumber,
        pageSize: this.page.pageSize,
        label: this.form.label,
        showAble: this.form.showAble
      };
      this.fullscreenLoading = false;
      this.$axios
        .post(`/api-r/report_property/config/page`, queryParams, {
          headers: {accessToken: this.userdata.token},
        })
        .then((res) => {
          const { data } = res || {}
          if (data.success) {
            this.fullscreenLoading = false;
            this.page.total = data.data.total || 0
            this.list = data.data.list || []
          }
        });
    },
    handleSearch(){
      this.page.pageNumber = 1;
      this.fullscreenLoading = true;
      this.loadTable();
    },
    handleReset(){
      this.form.label = undefined
      this.form.showAble = undefined
      this.page.pageNumber = 1;
      this.fullscreenLoading = true;
      this.loadTable();
    },
    handleSwitch({id}){
      console.log(id)
      this.$axios
        .put(`/api-r/report_property/config/${id}/enabled`,'', {
          headers: {accessToken: this.userdata.token},
        })
        .then((res) => {

        });

      //
      // this.$axios
      //   .put(
      //     `/api-r/report_property/config/${id}/enabled`,
      //     {
      //       headers: {accessToken: this.userdata.token},
      //     }
      //   )
      //   .then((res) => {
      //       const { data } = res || {}
      //       if (data.success) {
      //         this.loadTable()
      //       }
      //   });
    },
    handlePage(val){
      this.page.pageNumber = val.pageNum;
      this.page.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.loadTable();
    }
  }
}
</script>

<style scoped>
.col-box{
  border:1px solid #EBEEF5;
  min-height: 100%;
  padding: 20px;
  margin-right: 40px;
}
.left-box .title{
  background-color: #fbfafc;
  font-size: 16px;
  padding: 8px 15px;
}
.left-box li{
  list-style: none;
  font-size: 14px;
  padding: 6px 12px;
  margin: 12px 0;
  cursor: pointer;
}
.current-li{
  background-color: #ecf9f8;
}
.right-box{
  border:1px solid #EBEEF5;
  padding: 20px;
}
</style>
